export const colors = {
    // Quebec Taxi Primary Colors
    LandingPage_Background: '#FFFFFF',
    LandingPage_Description: '#1C1C1C',
    Button_Primary: '#4169E2',
    Button_Secondary: '#3558C9',
    Header_Background: "#4169E2",
    Header_Content: '#FFFFFF',
    Black: '#1C1C1C',
    Header: '#4169E2',
    Header_Text: "#FFFFFF",
    Header_Text_back: "#4752C4",
    Table_Header: '#5865F2',
    Action_Button_Back: '#5865F2',
    NAV_BUTTON: '#4169E2',
    FOOTER_BACKGROUND: '#2E2E2E',
    ALERT_BUTTON_GOTO_COLOR: "rgba(0,174,239,0.2)",
    ALERT_BUTTON_CLOSE_COLOR: "rgba(231,76,60,0.2)",
    HEADER: '#00AEEF',
    BORDER_BACKGROUND: "#E0E0E0",
    CAR_BOX_EVEN:'#F6BF1B',
    CAR_BOX_ODD:'#DEDFD5',
    CARD_LABEL:"#1C1C1C",
    CARD_DETAIL:"#F2F2F2",
    STATUS_COMPLETE:"#2ECC71",
    STATUS_CANCELED:"#E74C3C",
    STATUS_PENDING:"#F39C12",
    ROW_SELECTED:"#F2F2F2",
    TABLE_BORDER:"#E0E0E0",
    SUB_2:"#0095CC",
    WALLET_CARD:"#00AEEF",
    WALLET_CARD_SHADOW:"#888888",
    FACEBOOK_COLOR:"#3b5998",
    BLUE:"#00AEEF",

    // Quebec Taxi Service Colors
    TAXIPRIMARY: "#00AEEF",
    TAXISECONDORY: "#F2F2F2",

    DELIVERYPRIMARY: "#00AEEF",
    DELIVERYSECONDORY: "#F2F2F2",

    BIDTAXIPRIMARY: "#00AEEF",
    BIDTAXISECONDORY: "#F2F2F2",

    TRANSPARENT: "transparent",
    WHITE: "#FFFFFF",
    BLACK: "#1C1C1C",
    RED: "#E74C3C",
    GREEN: "#2ECC71",
    YELLOW: "#F39C12",
    VIOLET:"#00AEEF",
    FOOTERTOP: "#888888",

    // Additional Quebec Taxi Colors
    SKY: '#00AEEF',
    SKY_HOVER: '#0095CC',
    DARK_GRAY: '#2E2E2E',
    SOFT_BLACK: '#1C1C1C',
    LIGHT_GRAY: '#F2F2F2',
}